import styled from 'styled-components';

export const StyledHeadlines = styled.section`


`;

export const Heading = styled.h1`
    font-size:1rem;
    color: #8B8B8B;
    text-align: left;
    padding:0;
    margin:0;
    padding-top:20px;
    padding-bottom:20px;
`;

export const Image = styled.img`
    max-width:100%;
    height:auto;

`;

export const InfographicList = styled.div`
    display:flex;
    flex-wrap:wrap;
    justify-content: space-between;
`;

export const InfographicWrapper = styled.div`

    width:50%;
`;